export default "__VITE_ASSET__U0fdzzY4__"